import Image, { ImageDataType, ImgSrcDataType } from './Image';

export { ImageDataType, ImgSrcDataType };
export default Image;
